import { ProjectApiModel } from '@/core/models/api/project-api-model.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export enum ProjectActionTypes {
    LoadProjects = 'Load Projects',
    LoadProjectsSuccess = 'Load Projects Success',
    LoadProjectsFail = 'Load Projects Fail',
    LoadProjectById = 'Load Project By Id',
    LoadProjectByIdSuccess = 'Load Project By Id Success',
    LoadProjectByIdFail = 'Load Project By Id Fail',
    SetSelectedProject = 'Set Selected Project',
    ClearSelectedProject = 'Clear Selected Project',
    ClearProjects = 'Clear Projects'
}

export const ProjectActions = createActionGroup({
    source: 'Project',
    events: {
        [ProjectActionTypes.LoadProjects]: emptyProps(),
        [ProjectActionTypes.LoadProjectsSuccess]: props<{ projects: ProjectApiModel[] }>(),
        [ProjectActionTypes.LoadProjectsFail]: props<{ error: string }>(),
        [ProjectActionTypes.LoadProjectById]: props<{ projectId: number }>(),
        [ProjectActionTypes.LoadProjectByIdSuccess]: props<{ project: ProjectApiModel }>(),
        [ProjectActionTypes.LoadProjectByIdFail]: props<{ error: string }>(),
        [ProjectActionTypes.SetSelectedProject]: props<{ project: ProjectApiModel }>(),
        [ProjectActionTypes.ClearSelectedProject]: emptyProps(),
        [ProjectActionTypes.ClearProjects]: emptyProps(),
    }
});
